export enum PowerOfAttorneyContractType {
    HOLDER_POA_CUSTOMER = 6211,
    HOLDER_POA_ACCOUNT = 6212,
    POA_CUSTOMER = 102,
}
